import React from "react";

export const Header = ({ text }: { text: string }) => (
  <div className="lg:text-3xl text-2xl mb-10 font-bold capitalize text-[#324B4A]">{text}</div>
);
